import React, {
  Component,
  useState,
  useCallback,
  useRef,
  useEffect,
} from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import axios from "axios";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { serverApi } from "../../../../config/Keys";
import Alert from "react-s-alert";
import { thumbnail } from "../ImageResizerComponent";

function AlertDialog(props) {
  const [open, setOpen] = React.useState(!false);
  const [progress, setProgress] = React.useState(0);

  const handleClickOpen = () => {
    setOpen(true);
  };
  React.useEffect(() => {
    setOpen(true);
  }, [props.src]);
  const handleCancel = () => {
    setOpen(false);
    props.onCancelCrop();
  };

  const [filename, setFileName] = React.useState("");
  const handleComplete = async (file, originalFile) => {
    if (originalFile.name !== filename) {
      var newfile = new File([file], `${originalFile.name}`, {
        type: originalFile.type,
      });
      setFileName(`${originalFile.name}`);
      var data = new FormData();
      data.append("files", newfile);
      var combined = props.combined.replace(/[^a-zA-Z0-9]/g, "");
      if (props.thumbnail) {
        let thumb = await thumbnail(originalFile);
        let thumbFile = new File([thumb], `thumbnail/${originalFile.name}`, {
          type: originalFile.type,
        });
        let thumbData = new FormData();
        thumbData.append("files", thumbFile);
        await axios.post(
          `${serverApi}/upload-assets?uploadSide=${combined}&thumbnail=true`,
          thumbData,
          {
            onUploadProgress: (progressEvent) =>
              setProgress((progressEvent.loaded / progressEvent.total) * 100),
          }
        );
      }
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) =>
            setProgress((progressEvent.loaded / progressEvent.total) * 100),
        })
        .then((res) => {
          props.onCompleteCrop(res.data[0]);
          Alert.success(`<h4>Image Uploaded Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          setOpen(false);
          setProgress(0);
        })
        .catch((err) => {
          Alert.error(`<h4>Error while uploading the image</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          setOpen(false);
        });
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleComplete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Crop Image</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {progress !== 0 ? (
              <div
                class="progress image-upload-progress-mobile"
                style={{ minWidth: "450px" }}
              >
                <div
                  class="progress-bar bg-success"
                  style={{ width: `${progress}%` }}
                >
                  {Math.floor(progress)}% Uploaded{" "}
                </div>
              </div>
            ) : (
              <Crop
                src={props.src}
                handleComplete={handleComplete}
                handleCancel={handleCancel}
              />
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

class ImageCrop extends Component {
  render() {
    return (
      <div>
        <AlertDialog
          src={this.props.src}
          combined={this.props.combined}
          onCompleteCrop={this.props.onCompleteCrop}
          onCancelCrop={this.props.onCancelCrop}
          thumbnail={this.props.thumbnail}
        />
      </div>
    );
  }
}

export default ImageCrop;

function generateDownload(canvas, crop, handleComplete, originalFile) {
  if (!crop || !canvas) {
    return;
  }
  canvas.toBlob(
    (blob) => {
      const previewUrl = window.URL.createObjectURL(blob);
      handleComplete(blob, originalFile);
      window.URL.revokeObjectURL(previewUrl);
    },
    originalFile.type,
    1
  );
}

function Crop(props) {
  const [upImg, setUpImg] = useState(props.src);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({});
  const [completedCrop, setCompletedCrop] = useState(null);

  const onSelectFile = (e) => {
    if (e) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setUpImg(reader.result));
      reader.readAsDataURL(e);
    }
  };
  useEffect(() => {
    onSelectFile(props.src);
  }, [props.src]);
  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  return (
    <div className="App">
      <ReactCrop
        src={upImg}
        onImageLoaded={onLoad}
        crop={crop}
        onChange={(c) => setCrop(c)}
        onComplete={(c) => setCompletedCrop(c)}
        // maxHeight={250}
      />
      <div>
        <canvas
          ref={previewCanvasRef}
          // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
          style={{
            width: Math.round(completedCrop?.width ?? 0),
            height: Math.round(completedCrop?.height ?? 0),
          }}
        />
      </div>
      <div className="d-flex justify-content-end">
        <Button
          type="button"
          color="secondary"
          className="mr-2"
          onClick={() => props.handleCancel()}
        >
          Cancel
        </Button>

        <Button
          type="button"
          disabled={!completedCrop?.width || !completedCrop?.height}
          color="primary"
          onClick={() =>
            generateDownload(
              previewCanvasRef.current,
              completedCrop,
              props.handleComplete,
              props.src
            )
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
}

export const ImageCropMultiple = (props) => {
  return (
    <AlertDialogMultiple
      src={props.src}
      combined={props.combined}
      // onCompleteCrop={this.props.onCompleteCrop}
      onCancelCrop={props.onCancelCrop}
      onCompleteUploadMultipleCrop={props.onCompleteUploadMultipleCrop}
      thumbnail={props.thumbnail}
    />
  );
};

function AlertDialogMultiple(props) {
  const [open, setOpen] = React.useState(!false);
  const [progress, setProgress] = React.useState(0);
  const [filename, setFileName] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };
  React.useEffect(() => {
    setOpen(true);
  }, [props.src]);
  const handleCancel = () => {
    setOpen(false);
    props.onCancelCrop(props.src);
  };

  const handleComplete = async (file, originalFile) => {
    if (originalFile.name !== filename) {
      var newfile = new File([file], `${originalFile.name}`, {
        type: originalFile.type,
      });
      setFileName(`${originalFile.name}`);
      var data = new FormData();
      data.append("files", newfile);
      var combined = props.combined.replace(/[^a-zA-Z0-9]/g, "");
      if (props.thumbnail) {
        let thumb = await thumbnail(newfile);
        let thumbFile = new File([thumb], `thumbnail/${originalFile.name}`, {
          type: originalFile.type,
        });
        let thumbData = new FormData();
        thumbData.append("files", thumbFile);
        await axios.post(
          `${serverApi}/upload-assets?uploadSide=${combined}&thumbnail=true`,
          thumbData,
          {
            onUploadProgress: (progressEvent) =>
              setProgress((progressEvent.loaded / progressEvent.total) * 100),
          }
        );
      }
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
          onUploadProgress: (progressEvent) =>
            setProgress((progressEvent.loaded / progressEvent.total) * 100),
        })
        .then((res) => {
          props.onCompleteUploadMultipleCrop(res.data[0], originalFile);
          Alert.success(`<h4>Image Uploaded Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          setOpen(false);
          setProgress(0);
        })
        .catch((err) => {
          // this.setState({ multipleImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          setOpen(false);
        });
    } else {
      Alert.warning(`<h4>Please wait...</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
  // console.log(props.src);
  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleComplete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Crop Image</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {progress !== 0 ? (
              <div
                className="progress image-upload-progress-mobile"
                style={{ minWidth: "450px" }}
              >
                <div
                  className="progress-bar bg-success"
                  style={{ width: `${progress}%` }}
                >
                  {Math.floor(progress)}% Uploaded{" "}
                </div>
              </div>
            ) : (
              <Crop
                src={props.src}
                handleCancel={handleCancel}
                handleComplete={handleComplete}
              />
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
